import { useNavigate } from 'react-router-dom';

export const useRedirectUrl = () => {
  const navigate = useNavigate();

  const onRedirectUrl = (path: string, external = true) => {
    if (external) {
      window.location.href = path;
    } else {
      navigate(path);
    }
  };

  return {
    onRedirectUrl,
  };
};
